import { render, staticRenderFns } from "./size-pricing.vue?vue&type=template&id=165cc64c&scoped=true"
import script from "./size-pricing.vue?vue&type=script&lang=js"
export * from "./size-pricing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "165cc64c",
  null
  
)

export default component.exports